module.exports = __webpack_public_path__ + "img/re2025-square.019d013c.jpg";